import { SupportedLanguage } from '@/entities/SupportedLanguage';

export const getSupportedLanguages = (): Record<SupportedLanguage, true> => {
  return {
    'en-US': true,
    'zh-CN': true,
  };
};
